import errors from '@/modules/_global/mixins/errors';
import DataOptions from '@/modules/_global/classes/DataOptions';
import { cloneDeep, debounce, isEmpty } from 'lodash';

export const DEBOUNCE_DELAY = 300;

export default {
  mixins: [errors],

  data() {
    return {
      meta: {
        total: 0
      },
      filters: {},
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['id'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      items: []
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign(
        {},
        { paginationOptions: this.preparedOptions },
        { filters: this.filters }
      );
    }
  },

  watch: {
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    }
  },

  mounted() {
    if (!isEmpty(this.paginationOptions)) {
      this.options = cloneDeep(this.paginationOptions);
    }
  },

  methods: {
    getListData: debounce(function getDebouncedListData() {
      this.getItemsList({ params: this.params }).then(({ data }) => {
        this.items = data.data;
        this.meta = data.meta;
      });
    }, DEBOUNCE_DELAY),

    refreshData() {
      this.getListData();
    },

    setFilters(v) {
      this.filters = v;
      this.options.page = 1;
      this.refreshData();
    }
  }
};
